define([
	"dojo/_base/declare",
	"csi/def",
	"csi/reflection",
	"csi/table/NewFrom"
], function(declare,def,reflection,NewFrom) {

	return declare(NewFrom, {
		/**
		 * Disable the Subtype Field
		 * @param {csi.view.Widget} view
		 */
		onCreatePopup: function(view) {
			this.inherited(arguments);

			if (view.defView.m_id == def.DEFAULT_FORM_ID) {
				view.setFieldDisabled(reflection.ATTR_SUBTYPE, true);
			}
		}
	});
});